"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const FormValidators_1 = require("../decorators/form/FormValidators");
const newsletterUpsert_1 = require("../forms/upsert/newsletterUpsert");
const endpoints_1 = require("../forms/utils/endpoints");
const postFunctions_1 = require("../services/postFunctions");
const endpoints = new endpoints_1.default;
const postFunctions = new postFunctions_1.default(endpoints.baseURL, endpoints.registerEnv);
document.addEventListener('DOMContentLoaded', () => {
    const newsletter = document.querySelector('.newsletter-form');
    if (newsletter) {
        newsletter.addEventListener('submit', (event) => __awaiter(void 0, void 0, void 0, function* () {
            event.preventDefault();
            postFunctions.disableBtn(newsletter, true);
            const form = event.target;
            const errorMessage = yield (0, FormValidators_1.validateForm)(form);
            if (errorMessage) {
                postFunctions.disableBtn(newsletter, false);
            }
            else {
                try {
                    const response = yield (0, newsletterUpsert_1.newsletterUpsert)(form, renderMessageInfoNewsletter);
                    console.log(response);
                }
                catch (error) {
                    console.error('Form submission error:', error);
                }
            }
        }));
    }
});
const renderMessageInfoNewsletter = (form) => {
    const element = document.createElement('p');
    element.setAttribute('class', 'captcha__message');
    element.innerHTML = 'Thank you for subscribing';
    form.appendChild(element);
};
